import {
  LOGIN_SUCCESS,
  LOGOUT_USER_DETAILS_SUCCESS,
  SAVE_USER_DETAILS_SUCCESS,
  SET_NEW_PASSWORD_SUCCESS,
} from "./login.type";

const initialState = {
  accessToken: null,
  token: null,
  user: null,
};

const getAccessTokenFromPayload = (payload) =>
  payload?.tokenDetails?.accessToken || payload?.accessToken || null;

const getUserFromPayload = (payload) => {
  if (!payload) return null;
  if (payload.user) return payload.user;
  if (payload.userDetails) return payload.userDetails;
  const { tokenDetails, ...rest } = payload;
  return Object.keys(rest).length ? rest : null;
};

const updateAuthState = (state, payload) => {
  const accessToken = getAccessTokenFromPayload(payload);
  const user = getUserFromPayload(payload);

  return {
    ...state,
    ...(accessToken
      ? {
          accessToken,
          token: accessToken,
        }
      : {}),
    ...(user ? { user } : {}),
  };
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      return updateAuthState(state, action.payload);
    }
    case SAVE_USER_DETAILS_SUCCESS: {
      return updateAuthState(state, action.payload);
    }
    case SET_NEW_PASSWORD_SUCCESS: {
      return updateAuthState(state, action.payload);
    }

    case LOGOUT_USER_DETAILS_SUCCESS:
    case "LOGOUT_USER_SUCCESS":
    case "SESSION_EXPIRED":
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
